module.exports = __webpack_public_path__ + "shopping-cart.png?953f35ff085ae03868f0807f50110ddf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cart/shopping-cart.png
// module id = 32
// module chunks = 0